/* eslint-disable no-unused-vars */

import React from 'react';
import Icon from '@components/icon-component';

import style from './style.module.scss';
import TaskStatusAndPriority from '@components/task-status-priority';
import { useOpenLink } from '@hooks/useOpenLink';

const VesselsContainerInner = ({ moreInfoOfPSV }) => {
  const [openLink, setOpenLink] = useOpenLink(false);

  const openInDesktop = ({ link }) => {
    setOpenLink((prev) => !prev);
  };

  return (
    <>
      <div className={style.content}>
        {moreInfoOfPSV.verificationStatus && (
          <div className={style.verificationStatus}>
            <span className={style.title}>{moreInfoOfPSV.verificationStatus}</span>
            <Icon name={'labelReconciled'} className={style.iconClass} />
          </div>
        )}

        {moreInfoOfPSV.equipmentEditingStatus && (
          <TaskStatusAndPriority
            assetCard
            status={moreInfoOfPSV.equipmentEditingStatus}
            containerClass={style.equipmentStatusClass}
          />
        )}

        <span className={style.title}>{moreInfoOfPSV.title}</span>
        <div className={style.featherIconContainer}>
          <span className={style.name}>
            <div>{moreInfoOfPSV.name}</div>
            <Icon
              name={'feather-link'}
              height={14}
              width={14}
              onClick={() => {
                openInDesktop({ link: moreInfoOfPSV.link });
              }}
            />
          </span>

          {openLink && (
            <div
              className={style.showLink}
              onClick={(e) => {
                e?.stopPropagation();
                window.open(moreInfoOfPSV.link, '_blank');
                setOpenLink((prev) => !prev);
              }}
            >
              <div>
                <Icon name={'map-pin'} />
                <p>Go to equipment</p>
              </div>
            </div>
          )}
        </div>

        {moreInfoOfPSV.serial && (
          <span className={style.serial}> Serial #: {moreInfoOfPSV.serial}</span>
        )}
      </div>
    </>
  );
};

export default VesselsContainerInner;
